module.exports = __webpack_public_path__ + "static/img/m6.a323cd94.png";